import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./side-bar.module.scss";
import { navigationItems } from "./constans";

const SideBar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [activeHoverElementId, setActiveHoverElementId] = useState("");

  const getActiveLinkId = (() => {
    const activeIndex = navigationItems.findIndex((item) =>
      pathname.startsWith(item.navigation),
    );
    return activeIndex !== -1 ? `${activeIndex}` : "0";
  })();

  return (
    <div className={styles.sidebar}>
      <div className={styles.sidebarHeader}>
        <div className={styles.headerText}>
          <h2 className={styles.panelTitle}>Master Admin Panel</h2>
        </div>
      </div>
      <ul className={styles.sidebarNavigation}>
        {navigationItems?.map((el, i) => {
          const isActive = getActiveLinkId === `${i}`;
          const isHovered = activeHoverElementId === `${i}`;
          const isHighlighted = isActive || isHovered;

          return (
            <li
              className={styles.sidebarNavigationItem}
              style={{
                backgroundColor: isHighlighted ? "#F7F7F7" : "transparent",
                cursor: "pointer",
                height: 35,
              }}
              key={i}
              id={`${i}`}
              onMouseEnter={() => setActiveHoverElementId(`${i}`)}
              onMouseLeave={() => setActiveHoverElementId("")}
              onClick={() => {
                navigate(el.navigation);
              }}
            >
              <el.icon color={isHighlighted ? "#2E2E2E" : "black"} />
              <p
                style={{
                  color: isHighlighted ? "#2E2E2E" : "black",
                  fontWeight: isHighlighted ? "bold" : "200",
                }}
              >
                {el.name}
              </p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SideBar;
